var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-row', [_c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v("OPERATIONAL HISTORY - " + _vm._s(_vm.fleet.name))])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "md": "4"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Type",
            "label-for": "type"
          }
        }, [_c('b-form-select', {
          attrs: {
            "plain": "",
            "size": "sm",
            "placeholder": "Select type..."
          },
          model: {
            value: _vm.params.type,
            callback: function callback($$v) {
              _vm.$set(_vm.params, "type", $$v);
            },
            expression: "params.type"
          }
        }, [_c('option', {
          attrs: {
            "value": ""
          }
        }, [_vm._v("All")]), _c('option', {
          attrs: {
            "value": "progress"
          }
        }, [_vm._v("Progress")]), _c('option', {
          attrs: {
            "value": "finish"
          }
        }, [_vm._v("finish")])])], 1)], 1), _c('b-col', {
          attrs: {
            "md": "4"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Date",
            "label-for": "date"
          }
        }, [_c('date-picker', {
          staticClass: "w-100",
          attrs: {
            "type": "date",
            "range": "",
            "placeholder": "Select date range",
            "format": "DD-MM-YYYY"
          },
          model: {
            value: _vm.dateRange,
            callback: function callback($$v) {
              _vm.dateRange = $$v;
            },
            expression: "dateRange"
          }
        })], 1)], 1), _c('b-col', {
          attrs: {
            "md": "2"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Filter",
            "label-for": "filter"
          }
        }, [_c('b-button', {
          attrs: {
            "variant": "primary",
            "type": "button"
          },
          on: {
            "click": function click() {
              return _vm.fetchVoyageByTrips();
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-filter"
        })])], 1)], 1), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('b-row', [_c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('div', {
          staticClass: "d-flex flex-column mb-2"
        }, [_vm.list.length > 0 ? _c('div', {
          staticClass: "d-flex overflow-auto"
        }, [_c('table', {
          staticClass: "table table-striped"
        }, [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-truncate align-middle",
          staticStyle: {
            "width": "5px"
          },
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("NO")]), _c('th', {
          staticClass: "text-truncate align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("TYPE VOYAGE")]), _c('th', {
          staticClass: "text-truncate align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("TRIP INFO")]), _c('th', {
          staticClass: "text-truncate align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("STATUS")]), _c('th', {
          staticClass: "text-truncate align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("CARGO TYPE")]), _c('th', {
          staticClass: "text-truncate align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("CARGO LOADING")]), _c('th', {
          staticClass: "text-truncate align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("CARGO UNLOADING")]), _c('th', {
          staticClass: "text-truncate align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("START DATE")]), _c('th', {
          staticClass: "text-truncate align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("END DATE")]), _c('th', {
          staticClass: "text-center",
          attrs: {
            "colspan": "18"
          }
        }, [_vm._v("Port of Loading")]), _c('th', {
          staticClass: "text-center bg-warning",
          attrs: {
            "colspan": "16"
          }
        }, [_vm._v("Port of Discharge")]), _c('th', {
          staticClass: "text-center align-middle",
          staticStyle: {
            "width": "5px",
            "position": "sticky",
            "right": "0",
            "z-index": "1"
          },
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("Action")])]), _c('tr', [_c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("Agen POL")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("POL Grab Type")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("POL FC Name")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("POL MV Name")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("BL Date")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("NOR")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("NOA")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("Anchor Up")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("In Position / Berthing")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("Commenced")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("Completed")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("Draught Survey")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("Second Berthing")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("Cast Out")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("LHV")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("Document on Board")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("Departure to POD")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("Remarks")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("Agen POD")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("POD Grab Type")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("POD FC Name")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("POD MV Name")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("Arival Time POD")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("NOR")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("NOA")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("Anchor Up")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("In Position / Berthing")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("Commenced")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("Completed")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("Draught Survey")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("Second Berthing")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("Cast Out")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("Departure to POL")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("Remarks")])])]), _c('tbody', _vm._l(_vm.list, function (state, index) {
          var _state$tripRecord, _state$tripRecord2, _state$tripRecord3, _state$tripRecord4, _state$tripRecord4$po, _state$tripRecord5, _state$tripRecord6, _state$tripRecord6$po, _state$tripRecord7, _state$tripRecord8, _state$tripRecord9, _state$tripRecord$sta, _state$tripRecord0, _state$tripRecord$car, _state$tripRecord1, _Number$toLocaleStrin, _Number, _state$tripRecord10, _Number$toLocaleStrin2, _Number2, _state$tripRecord11, _state$tripRecord12, _state$tripRecord13, _state$tripRecord14, _state$tripRecord15, _state$tripRecord16, _state$tripRecord17, _state$tripRecord18, _state$tripRecord19, _state$tripRecord20, _state$tripRecord21, _state$tripRecord22, _state$tripRecord23, _state$tripRecord24, _state$tripRecord25, _state$tripRecord26, _state$tripRecord27, _state$tripRecord28, _state$tripRecord29, _Number$toLocaleStrin3, _Number3, _state$tripRecord30, _state$tripRecord31, _state$tripRecord32, _state$tripRecord33, _state$tripRecord34, _state$tripRecord35, _state$tripRecord36, _state$tripRecord37, _state$tripRecord38, _state$tripRecord39, _state$tripRecord40, _state$tripRecord41, _state$tripRecord42, _state$tripRecord43, _state$tripRecord44, _state$tripRecord45, _state$tripRecord46, _state$tripRecord47, _state$tripRecord48, _state$tripRecord49, _state$tripRecord50, _state$tripRecord51, _state$tripRecord52, _state$tripRecord53, _state$tripRecord54, _state$tripRecord55, _Number$toLocaleStrin4, _Number4, _state$tripRecord56, _state$tripRecord57, _state$tripRecord58, _state$tripRecord59, _state$tripRecord60, _state$tripRecord61, _state$tripRecord62, _state$tripRecord63, _state$tripRecord64, _state$tripRecord65, _state$tripRecord66;
          return _c('tr', {
            key: index
          }, [_c('td', [_vm._v(_vm._s(index + 1))]), _c('td', {
            staticClass: "text-truncate cursor-pointer",
            on: {
              "click": function click($event) {
                return _vm.openSlideDetailRealisasi('PREVIEW', state);
              }
            }
          }, [_c('div', {
            staticClass: "d-flex flex-column"
          }, [_vm._l(state === null || state === void 0 ? void 0 : state.vehicle, function (v, v_index) {
            return _c('span', {
              key: "h-v-".concat(v_index),
              staticClass: "fs-5 mb-1"
            }, [v.id != Number(_vm.$route.query.vehicleId) ? _c('b-badge', {
              attrs: {
                "variant": "success"
              }
            }, [_vm._v(_vm._s(v.name))]) : _vm._e()], 1);
          }), state !== null && state !== void 0 && (_state$tripRecord = state.tripRecord) !== null && _state$tripRecord !== void 0 && _state$tripRecord.voyageType ? _c('b-badge', {
            attrs: {
              "variant": "primary"
            }
          }, [_vm._v(_vm._s(_vm.formatString(state === null || state === void 0 ? void 0 : (_state$tripRecord2 = state.tripRecord) === null || _state$tripRecord2 === void 0 ? void 0 : _state$tripRecord2.voyageType)))]) : _vm._e()], 2)]), _c('td', {
            staticClass: "text-truncate"
          }, [state !== null && state !== void 0 && (_state$tripRecord3 = state.tripRecord) !== null && _state$tripRecord3 !== void 0 && _state$tripRecord3.id ? _c('div', {
            staticClass: "d-flex flex-column"
          }, [_c('div', {
            staticClass: "d-flex align-items-center text-primary"
          }, [_c('i', {
            staticClass: "fas fa-map-pin mr-2"
          }), _c('strong', {
            staticClass: "mb-0 mr-1"
          }, [_vm._v(_vm._s((state === null || state === void 0 ? void 0 : (_state$tripRecord4 = state.tripRecord) === null || _state$tripRecord4 === void 0 ? void 0 : (_state$tripRecord4$po = _state$tripRecord4.portLoading) === null || _state$tripRecord4$po === void 0 ? void 0 : _state$tripRecord4$po.portName) || (state === null || state === void 0 ? void 0 : (_state$tripRecord5 = state.tripRecord) === null || _state$tripRecord5 === void 0 ? void 0 : _state$tripRecord5.portLoadingOther)))])]), _c('div', {
            staticClass: "dashed-border"
          }), _c('div', {
            staticClass: "d-flex align-items-center text-primary"
          }, [_c('i', {
            staticClass: "fa fa-map-pin mr-2"
          }), _c('strong', {
            staticClass: "mb-0 mr-1"
          }, [_vm._v(_vm._s((state === null || state === void 0 ? void 0 : (_state$tripRecord6 = state.tripRecord) === null || _state$tripRecord6 === void 0 ? void 0 : (_state$tripRecord6$po = _state$tripRecord6.portDischarge) === null || _state$tripRecord6$po === void 0 ? void 0 : _state$tripRecord6$po.portName) || (state === null || state === void 0 ? void 0 : (_state$tripRecord7 = state.tripRecord) === null || _state$tripRecord7 === void 0 ? void 0 : _state$tripRecord7.portDischargeOther)))])])]) : _c('div', {
            staticClass: "d-flex align-items-center text-danger"
          }, [_c('i', {
            staticClass: "ri-close-circle-line mr-2"
          }), _vm._v(" No trip yet ")])]), _c('td', [_c('b-badge', {
            class: "text-xl text-uppercase mr-2",
            attrs: {
              "variant": "".concat((state === null || state === void 0 ? void 0 : (_state$tripRecord8 = state.tripRecord) === null || _state$tripRecord8 === void 0 ? void 0 : _state$tripRecord8.status) === 'Progress' ? 'warning' : (state === null || state === void 0 ? void 0 : (_state$tripRecord9 = state.tripRecord) === null || _state$tripRecord9 === void 0 ? void 0 : _state$tripRecord9.status) === 'Finish' ? 'success' : 'primary')
            }
          }, [_vm._v(_vm._s((_state$tripRecord$sta = state === null || state === void 0 ? void 0 : (_state$tripRecord0 = state.tripRecord) === null || _state$tripRecord0 === void 0 ? void 0 : _state$tripRecord0.status) !== null && _state$tripRecord$sta !== void 0 ? _state$tripRecord$sta : '-'))])], 1), _c('td', [_vm._v(_vm._s((_state$tripRecord$car = state === null || state === void 0 ? void 0 : (_state$tripRecord1 = state.tripRecord) === null || _state$tripRecord1 === void 0 ? void 0 : _state$tripRecord1.cargoType) !== null && _state$tripRecord$car !== void 0 ? _state$tripRecord$car : '-'))]), _c('td', [_vm._v(_vm._s((_Number$toLocaleStrin = (_Number = Number(state === null || state === void 0 ? void 0 : (_state$tripRecord10 = state.tripRecord) === null || _state$tripRecord10 === void 0 ? void 0 : _state$tripRecord10.cargoLoading)) === null || _Number === void 0 ? void 0 : _Number.toLocaleString()) !== null && _Number$toLocaleStrin !== void 0 ? _Number$toLocaleStrin : '0'))]), _c('td', [_vm._v(_vm._s((_Number$toLocaleStrin2 = (_Number2 = Number(state === null || state === void 0 ? void 0 : (_state$tripRecord11 = state.tripRecord) === null || _state$tripRecord11 === void 0 ? void 0 : _state$tripRecord11.cargoUnloading)) === null || _Number2 === void 0 ? void 0 : _Number2.toLocaleString()) !== null && _Number$toLocaleStrin2 !== void 0 ? _Number$toLocaleStrin2 : '0'))]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && (_state$tripRecord12 = state.tripRecord) !== null && _state$tripRecord12 !== void 0 && _state$tripRecord12.startDate ? _vm.moment(state === null || state === void 0 ? void 0 : (_state$tripRecord13 = state.tripRecord) === null || _state$tripRecord13 === void 0 ? void 0 : _state$tripRecord13.startDate, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && (_state$tripRecord14 = state.tripRecord) !== null && _state$tripRecord14 !== void 0 && _state$tripRecord14.endDate ? _vm.moment(state === null || state === void 0 ? void 0 : (_state$tripRecord15 = state.tripRecord) === null || _state$tripRecord15 === void 0 ? void 0 : _state$tripRecord15.endDate, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(_vm._s((state === null || state === void 0 ? void 0 : state.tripRecord.agentPol) || '-'))]), _c('td', {
            staticClass: "text-truncate text-capitalize"
          }, [_vm._v(_vm._s(_vm.formatString((state === null || state === void 0 ? void 0 : state.tripRecord.polGrabType) || '')))]), _c('td', {
            staticClass: "text-truncate text-capitalize"
          }, [_vm._v(_vm._s((state === null || state === void 0 ? void 0 : state.tripRecord.polFcName) || '-'))]), _c('td', {
            staticClass: "text-truncate text-capitalize"
          }, [_vm._v(_vm._s((state === null || state === void 0 ? void 0 : state.tripRecord.polMvName) || '-'))]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && (_state$tripRecord16 = state.tripRecord) !== null && _state$tripRecord16 !== void 0 && _state$tripRecord16.polBlDate ? _vm.moment(state === null || state === void 0 ? void 0 : (_state$tripRecord17 = state.tripRecord) === null || _state$tripRecord17 === void 0 ? void 0 : _state$tripRecord17.polBlDate, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && (_state$tripRecord18 = state.tripRecord) !== null && _state$tripRecord18 !== void 0 && _state$tripRecord18.polNor ? _vm.moment(state === null || state === void 0 ? void 0 : (_state$tripRecord19 = state.tripRecord) === null || _state$tripRecord19 === void 0 ? void 0 : _state$tripRecord19.polNor, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && (_state$tripRecord20 = state.tripRecord) !== null && _state$tripRecord20 !== void 0 && _state$tripRecord20.polNoa ? _vm.moment(state === null || state === void 0 ? void 0 : (_state$tripRecord21 = state.tripRecord) === null || _state$tripRecord21 === void 0 ? void 0 : _state$tripRecord21.polNoa, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && (_state$tripRecord22 = state.tripRecord) !== null && _state$tripRecord22 !== void 0 && _state$tripRecord22.polAnchorUp ? _vm.moment(state === null || state === void 0 ? void 0 : (_state$tripRecord23 = state.tripRecord) === null || _state$tripRecord23 === void 0 ? void 0 : _state$tripRecord23.polAnchorUp, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && (_state$tripRecord24 = state.tripRecord) !== null && _state$tripRecord24 !== void 0 && _state$tripRecord24.polBerthing ? _vm.moment(state === null || state === void 0 ? void 0 : (_state$tripRecord25 = state.tripRecord) === null || _state$tripRecord25 === void 0 ? void 0 : _state$tripRecord25.polBerthing, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && (_state$tripRecord26 = state.tripRecord) !== null && _state$tripRecord26 !== void 0 && _state$tripRecord26.polCommenced ? _vm.moment(state === null || state === void 0 ? void 0 : (_state$tripRecord27 = state.tripRecord) === null || _state$tripRecord27 === void 0 ? void 0 : _state$tripRecord27.polCommenced, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && (_state$tripRecord28 = state.tripRecord) !== null && _state$tripRecord28 !== void 0 && _state$tripRecord28.polCompleted ? _vm.moment(state === null || state === void 0 ? void 0 : (_state$tripRecord29 = state.tripRecord) === null || _state$tripRecord29 === void 0 ? void 0 : _state$tripRecord29.polCompleted, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate text-center"
          }, [_vm._v(_vm._s((_Number$toLocaleStrin3 = (_Number3 = Number(state === null || state === void 0 ? void 0 : (_state$tripRecord30 = state.tripRecord) === null || _state$tripRecord30 === void 0 ? void 0 : _state$tripRecord30.polDraughtSurvey)) === null || _Number3 === void 0 ? void 0 : _Number3.toLocaleString()) !== null && _Number$toLocaleStrin3 !== void 0 ? _Number$toLocaleStrin3 : 0))]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && (_state$tripRecord31 = state.tripRecord) !== null && _state$tripRecord31 !== void 0 && _state$tripRecord31.polCastIn ? _vm.moment(state === null || state === void 0 ? void 0 : (_state$tripRecord32 = state.tripRecord) === null || _state$tripRecord32 === void 0 ? void 0 : _state$tripRecord32.polCastIn, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && (_state$tripRecord33 = state.tripRecord) !== null && _state$tripRecord33 !== void 0 && _state$tripRecord33.polCastOut ? _vm.moment(state === null || state === void 0 ? void 0 : (_state$tripRecord34 = state.tripRecord) === null || _state$tripRecord34 === void 0 ? void 0 : _state$tripRecord34.polCastOut, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && (_state$tripRecord35 = state.tripRecord) !== null && _state$tripRecord35 !== void 0 && _state$tripRecord35.polLhv ? _vm.moment(state === null || state === void 0 ? void 0 : (_state$tripRecord36 = state.tripRecord) === null || _state$tripRecord36 === void 0 ? void 0 : _state$tripRecord36.polLhv, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && (_state$tripRecord37 = state.tripRecord) !== null && _state$tripRecord37 !== void 0 && _state$tripRecord37.polDocOnBoard ? _vm.moment(state === null || state === void 0 ? void 0 : (_state$tripRecord38 = state.tripRecord) === null || _state$tripRecord38 === void 0 ? void 0 : _state$tripRecord38.polDocOnBoard, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && (_state$tripRecord39 = state.tripRecord) !== null && _state$tripRecord39 !== void 0 && _state$tripRecord39.polDeparture ? _vm.moment(state === null || state === void 0 ? void 0 : (_state$tripRecord40 = state.tripRecord) === null || _state$tripRecord40 === void 0 ? void 0 : _state$tripRecord40.polDeparture, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-center"
          }, [_c('div', {
            staticClass: "text-left",
            staticStyle: {
              "width": "400px"
            }
          }, [_vm._v(" " + _vm._s(state === null || state === void 0 ? void 0 : (_state$tripRecord41 = state.tripRecord) === null || _state$tripRecord41 === void 0 ? void 0 : _state$tripRecord41.polRemark) + " ")])]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(_vm._s((state === null || state === void 0 ? void 0 : state.tripRecord.agentPod) || '-'))]), _c('td', {
            staticClass: "text-truncate text-capitalize"
          }, [_vm._v(_vm._s(_vm.formatString((state === null || state === void 0 ? void 0 : state.tripRecord.podGrabType) || '')))]), _c('td', {
            staticClass: "text-truncate text-capitalize"
          }, [_vm._v(_vm._s((state === null || state === void 0 ? void 0 : state.tripRecord.podFcName) || '-'))]), _c('td', {
            staticClass: "text-truncate text-capitalize"
          }, [_vm._v(_vm._s((state === null || state === void 0 ? void 0 : state.tripRecord.podMvName) || '-'))]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && (_state$tripRecord42 = state.tripRecord) !== null && _state$tripRecord42 !== void 0 && _state$tripRecord42.podArrivalTime ? _vm.moment(state === null || state === void 0 ? void 0 : (_state$tripRecord43 = state.tripRecord) === null || _state$tripRecord43 === void 0 ? void 0 : _state$tripRecord43.podArrivalTime, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate text-center"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && (_state$tripRecord44 = state.tripRecord) !== null && _state$tripRecord44 !== void 0 && _state$tripRecord44.podNor ? _vm.moment(state === null || state === void 0 ? void 0 : (_state$tripRecord45 = state.tripRecord) === null || _state$tripRecord45 === void 0 ? void 0 : _state$tripRecord45.podNor, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate text-center"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && (_state$tripRecord46 = state.tripRecord) !== null && _state$tripRecord46 !== void 0 && _state$tripRecord46.podNoa ? _vm.moment(state === null || state === void 0 ? void 0 : (_state$tripRecord47 = state.tripRecord) === null || _state$tripRecord47 === void 0 ? void 0 : _state$tripRecord47.podNoa, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && (_state$tripRecord48 = state.tripRecord) !== null && _state$tripRecord48 !== void 0 && _state$tripRecord48.podAnchorUp ? _vm.moment(state === null || state === void 0 ? void 0 : (_state$tripRecord49 = state.tripRecord) === null || _state$tripRecord49 === void 0 ? void 0 : _state$tripRecord49.podAnchorUp, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && (_state$tripRecord50 = state.tripRecord) !== null && _state$tripRecord50 !== void 0 && _state$tripRecord50.podBerthing ? _vm.moment(state === null || state === void 0 ? void 0 : (_state$tripRecord51 = state.tripRecord) === null || _state$tripRecord51 === void 0 ? void 0 : _state$tripRecord51.podBerthing, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && (_state$tripRecord52 = state.tripRecord) !== null && _state$tripRecord52 !== void 0 && _state$tripRecord52.podCommenced ? _vm.moment(state === null || state === void 0 ? void 0 : (_state$tripRecord53 = state.tripRecord) === null || _state$tripRecord53 === void 0 ? void 0 : _state$tripRecord53.podCommenced, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && (_state$tripRecord54 = state.tripRecord) !== null && _state$tripRecord54 !== void 0 && _state$tripRecord54.podCompleted ? _vm.moment(state === null || state === void 0 ? void 0 : (_state$tripRecord55 = state.tripRecord) === null || _state$tripRecord55 === void 0 ? void 0 : _state$tripRecord55.podCompleted, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', [_vm._v(_vm._s((_Number$toLocaleStrin4 = (_Number4 = Number(state === null || state === void 0 ? void 0 : (_state$tripRecord56 = state.tripRecord) === null || _state$tripRecord56 === void 0 ? void 0 : _state$tripRecord56.podDraughtSurvey)) === null || _Number4 === void 0 ? void 0 : _Number4.toLocaleString()) !== null && _Number$toLocaleStrin4 !== void 0 ? _Number$toLocaleStrin4 : '0'))]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && (_state$tripRecord57 = state.tripRecord) !== null && _state$tripRecord57 !== void 0 && _state$tripRecord57.podCastIn ? _vm.moment(state === null || state === void 0 ? void 0 : (_state$tripRecord58 = state.tripRecord) === null || _state$tripRecord58 === void 0 ? void 0 : _state$tripRecord58.podCastIn, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && (_state$tripRecord59 = state.tripRecord) !== null && _state$tripRecord59 !== void 0 && _state$tripRecord59.podCastOut ? _vm.moment(state === null || state === void 0 ? void 0 : (_state$tripRecord60 = state.tripRecord) === null || _state$tripRecord60 === void 0 ? void 0 : _state$tripRecord60.podCastOut, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && (_state$tripRecord61 = state.tripRecord) !== null && _state$tripRecord61 !== void 0 && _state$tripRecord61.podDeparture ? _vm.moment(state === null || state === void 0 ? void 0 : (_state$tripRecord62 = state.tripRecord) === null || _state$tripRecord62 === void 0 ? void 0 : _state$tripRecord62.podDeparture, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-center"
          }, [_c('div', {
            staticClass: "text-left",
            staticStyle: {
              "width": "380px"
            }
          }, [_vm._v(" " + _vm._s(state === null || state === void 0 ? void 0 : (_state$tripRecord63 = state.tripRecord) === null || _state$tripRecord63 === void 0 ? void 0 : _state$tripRecord63.podRemark) + " ")])]), _c('td', {
            staticClass: "text-center align-middle",
            staticStyle: {
              "width": "5px",
              "position": "sticky",
              "right": "0",
              "z-index": "1"
            }
          }, [_c('b-dropdown', {
            attrs: {
              "size": "sm",
              "variant": "dark",
              "toggle-class": "text-decoration-none",
              "text": "Actions",
              "dropright": "",
              "no-caret": ""
            },
            scopedSlots: _vm._u([{
              key: "button-content",
              fn: function fn() {
                return [_vm._v(" Actions "), _c('i', {
                  staticClass: "fa fa-chevron-down ml-1"
                })];
              },
              proxy: true
            }], null, true)
          }, [_c('b-dropdown-item', {
            attrs: {
              "variant": "primary"
            },
            on: {
              "click": function click($event) {
                return _vm.openSlideDetailRealisasi('PREVIEW', state);
              }
            }
          }, [_c('i', {
            staticClass: "fas fa-eye mr-2"
          }), _vm._v(" Detail ")]), (state === null || state === void 0 ? void 0 : (_state$tripRecord64 = state.tripRecord) === null || _state$tripRecord64 === void 0 ? void 0 : _state$tripRecord64.status) !== 'Finish' ? _c('b-dropdown-item', {
            attrs: {
              "variant": "primary"
            },
            on: {
              "click": function click($event) {
                return _vm.openSlideEditOperational('EDIT', state);
              }
            }
          }, [_c('i', {
            staticClass: "fas fa-arrow-circle-down mr-2"
          }), _vm._v(" Edit ")]) : _vm._e(), !(state !== null && state !== void 0 && state.activities) && (state === null || state === void 0 ? void 0 : (_state$tripRecord65 = state.tripRecord) === null || _state$tripRecord65 === void 0 ? void 0 : _state$tripRecord65.status) !== 'Finish' ? _c('b-dropdown-divider') : _vm._e(), !(state !== null && state !== void 0 && state.activities) && (state === null || state === void 0 ? void 0 : (_state$tripRecord66 = state.tripRecord) === null || _state$tripRecord66 === void 0 ? void 0 : _state$tripRecord66.status) !== 'Finish' ? _c('b-dropdown-item', {
            attrs: {
              "href": "#",
              "variant": "danger"
            },
            on: {
              "click": function click($event) {
                return _vm.onDeleteTripRecord(state === null || state === void 0 ? void 0 : state.tripRecord.id);
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-trash mr-2"
          }), _vm._v(" Remove ")]) : _vm._e()], 1)], 1)]);
        }), 0)])]) : _vm._e()])]), _c('b-col', {
          staticClass: "text-center",
          attrs: {
            "md": "12"
          }
        }, [_vm.list.length > 0 ? _c('div', {
          staticClass: "mt-3"
        }, [_c('b-pagination', {
          attrs: {
            "total-rows": _vm.meta.total,
            "per-page": _vm.meta.perPage,
            "first-number": "",
            "align": "center"
          },
          on: {
            "change": _vm.fetchVoyageByTrips
          },
          model: {
            value: _vm.meta.currentPage,
            callback: function callback($$v) {
              _vm.$set(_vm.meta, "currentPage", $$v);
            },
            expression: "meta.currentPage"
          }
        })], 1) : _c('strong', {
          staticClass: "text-center text-muted"
        }, [_vm._v("Data not found.")])])], 1)], 1)], 1)];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-sidebar', {
    attrs: {
      "id": "slideDetailRealisasi",
      "title": "Detail Real Shipment",
      "width": "100%",
      "backdrop-variant": "dark",
      "bg-variant": "white",
      "right": "",
      "backdrop": "",
      "shadow": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var hide = _ref.hide;
        return [_c('SlideDetailRealisasi', {
          attrs: {
            "id": _vm.id,
            "closeSlideDetailRealisasi": _vm.closeSlideDetailRealisasi
          }
        })];
      }
    }]),
    model: {
      value: _vm.slideDetailRealisasi,
      callback: function callback($$v) {
        _vm.slideDetailRealisasi = $$v;
      },
      expression: "slideDetailRealisasi"
    }
  })], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-sidebar', {
    attrs: {
      "id": "slideEditOperational",
      "title": "Edit Operational",
      "width": "80%",
      "backdrop-variant": "dark",
      "bg-variant": "white",
      "right": "",
      "backdrop": "",
      "shadow": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var hide = _ref2.hide;
        return [_c('SlideEditOperational', {
          attrs: {
            "id": _vm.id,
            "closeSlideEditOperational": _vm.closeSlideEditOperational
          }
        })];
      }
    }]),
    model: {
      value: _vm.slideEditOperational,
      callback: function callback($$v) {
        _vm.slideEditOperational = $$v;
      },
      expression: "slideEditOperational"
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }